export default {
      id: "gallery-video-usage",
      viewBox: "0 0 80 80",
      url: "/assets/" + "icons.svg#gallery-video",
      toString: function () {
        return this.url;
      }
    }